import React from 'react'
import verify from '../../../assets/img/icons/Vector.svg'

const VerifiedBadge: React.FC = () => {
  return (
    <div
      className="product-verified-badge text-uppercase fs-10 fw-bold"
      style={{
        color: '#3874FF',
        backgroundColor: '#ADC5FF',
        padding: '0.2em 0.2em',
      }}
    >
      <img
        src={verify}
        alt="verify"
        style={{
          width: '1.4em',
          height: '1.4em',
          paddingBottom: '',
        }}
      />
      &nbsp;
      <span>Verificado</span>
    </div>
  )
}

export default VerifiedBadge
